import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty, isUndefined } from "lodash";
import CreditInfo from "@components/CreditInfo/CreditInfo";
import { history } from "@helpers/history";
import { isObjEmpty } from "@helpers/utils";

const BORDER_TOP_COLOR = "#d7de00";

function CreditosProductivos(props) {
  const {
    match: { params },
  } = props;
  const [idCredito, setIdCredito] = useState("");
  const [credit, setCredit] = useState({});

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { creditosProductivos } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    setIdCredito(params?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const defRoute = rutas?.filter(
      (route) => route?.name === "Creditos Productivos Listado"
    );

    const prevRoute = defRoute.map((route) => {
      return {
        url: route.url.replace("/:id", ""),
        text: route.h1,
      };
    });

    if (!isEmpty(idCredito) && !isEmpty(creditosProductivos)) {
      let promise = new Promise((resolve, reject) => {
        let normalizeCredits = [];
        let resMatch = {};
        if (!isEmpty(creditosProductivos?.aCCreditosProductivos)) {
          normalizeCredits = creditosProductivos.aCCreditosProductivos.map(
            (credito) => ({
              ...credito,
              idCreditoProductivo: credito.idCreditoProductivo
                .toLowerCase()
                .replaceAll(" ", "-"),
              rutaPrevia: prevRoute,
            })
          );
          resMatch =
            normalizeCredits &&
            normalizeCredits.filter(
              (credito) =>
                credito.idCreditoProductivo ===
                idCredito.toLowerCase().replaceAll(" ", "-")
            )[0];
        }
        if (
          !isEmpty(creditosProductivos?.aCCreditosProductivos) &&
          !isEmpty(creditosProductivos?.aCBotonSoliciteSuCredito)
        ) {
          resMatch = {
            ...resMatch,
            btnSolicite: {
              images: creditosProductivos.aCBotonSoliciteSuCredito[0],
              url: resMatch?.urlformulariosolicitesucredito?.url,
              alt: resMatch?.urlformulariosolicitesucredito?.text,
            },
          };
        }
        if (
          !isEmpty(creditosProductivos?.aCCreditosProductivos) &&
          !isEmpty(creditosProductivos?.aCBotonCalculesuCredito)
        ) {
          resMatch = {
            ...resMatch,
            btnCalcule: {
              images: creditosProductivos.aCBotonCalculesuCredito[0],
              url: "/",
              alt: "Calcule su Crédito",
            },
          };
        }
        resolve(resMatch);
      });

      promise.then((res) => {
        !isUndefined(res.btnSolicite.url) && !isEmpty(res)
          ? setCredit({
              id: res.idCreditoProductivo,
              title: res.titulo,
              description: res.descripcion?.html,
              details: res.bag?.contentItems,
              btnSolicite: res.btnSolicite,
              btnCalcule: res.btnCalcule,
              prevRoute: res.rutaPrevia,
            })
          : isObjEmpty(credit) && history.push('/no-encontrado')
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditosProductivos, idCredito]);

  return (
    <>
      {!isEmpty(credit) && (
        <CreditInfo credito={credit} borderTopColor={BORDER_TOP_COLOR} />
      )}
    </>
  );
}

export default CreditosProductivos;
